import { Component, OnInit, ChangeDetectionStrategy, Renderer2, ElementRef, Input } from '@angular/core';
import { WindowRefService } from '@app/shared/services/windowRef/window-ref.service';
import { CookieService } from '@app/core/cookies';

@Component({
  selector: 'vc-smart-app-banner',
  templateUrl: './smart-app-banner.component.html',
  styleUrls: ['./smart-app-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmartAppBannerComponent implements OnInit {
  @Input() osList = { isAndroid: false, isIos: false };

  public showBanner = false;
  public smartAppBannerLink = '';

  constructor(
    private winRef: WindowRefService,
    private _renderer: Renderer2,
    private _elementRef: ElementRef<HTMLElement>,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    if (!this.cookieService.get('smartBanner')) {
      this.setSmartAppBannerInfo();
    }
  }

  setSmartAppBannerInfo() {
    if (this.osList.isAndroid) {
      this.showBanner = true;
      this._renderer.addClass(document.body, 'hasSmartBanner');
      this.smartAppBannerLink = 'https://app.adjust.com/4v0cok';
    }
  }

  openLink() {
    this.winRef.nativeWindow.location = this.smartAppBannerLink;
    this.closeBanner();
  }

  closeBanner() {
    this._renderer.setStyle(this._elementRef.nativeElement.querySelector('.smartAppBanner'), 'margin-top', '-80px');
    this._renderer.removeClass(document.body, 'hasSmartBanner');
    setTimeout(() => {
      this._renderer.removeChild(
        this._elementRef.nativeElement,
        this._elementRef.nativeElement.querySelector('.smartAppBanner')
      );
    }, 500);
    this.cookieService.set('smartBanner', 'show');
  }
}
